<script setup>
import { computed, inject } from 'vue';
import { styleVars } from './shared.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const event = inject('tiqCurrentEvent', null);
// A visitor never meets the slot's placeholder: with no real event
// to render it draws nothing, and only the editor keeps the stand-in.
const editing = inject('tiqEditorCanvas', false);

// A real event with no summary renders nothing; the editor canvas,
// which has no event, shows what the slot is for.
const excerpt = computed(() => (event ? (event.excerpt || '') : 'Optional summary of the event.'));
const align = computed(() => (['left', 'center', 'right'].includes(props.config.align) ? props.config.align : 'left'));
</script>

<template>
    <section v-if="(excerpt) && (event || editing)"
             :id="config.anchor_id || null"
             class="th-block th-sec th-sec--tight th-eexcerpt"
             :class="`is-align-${align}`"
             :style="styleVars(config)">
        <div class="th-wrap">
            <p class="th-lede th-eexcerpt__text">{{ excerpt }}</p>
        </div>
    </section>
</template>

<style scoped>
.th-eexcerpt__text { max-width: 62ch; font-size: clamp(18px, 1.7vw, 21px); line-height: 1.6; }
.th-eexcerpt.is-align-center { text-align: center; }
.th-eexcerpt.is-align-center .th-eexcerpt__text { margin: 0 auto; }
.th-eexcerpt.is-align-right { text-align: right; }
.th-eexcerpt.is-align-right .th-eexcerpt__text { margin-left: auto; }
</style>
